const link_list = {
    routePath: 'edrequests',
    actionName: 'count',
    iconClass: 'fa-solid fa-code-pull-request',
    title: 'Recent Ed Requests ',
    search: {
        status: {
            key: 'status',
            value: 'Requested',
        },
    },
    sort: {
        order: 'asc',
        column: 'date_entered',
    },
    perPage: 10,
}
export default { link_list }